import React from 'react'
import Nav from '../Utils/Nav'
import Footer from '../Utils/Footer'
import { Link } from 'react-router-dom'



const data = [
    {
        "title": "Impact of Covid-19 pandemic on travel behaviour of people",
        "agency": "ICSSR",
        "amount": "₹4.20",
        "pi": "Dr. Rahul T.M"
      },
      {
        "title": "Development of low cost Artificial Intelligence System for early detection of landslide",
        "agency": "DST-NRDMS",
        "amount": "₹43.00",
        "pi": "Dr. Naveen James PI, Dr. Reet Kamal Tiwari and Dr. C. K. Narayanan"
      },
      {
        "title": "Utilisation of rice husk ash, bagasse ash and bottom ash in highway embankment",
        "agency": "NHAI",
        "amount": "₹53.38",
        "pi": "Dr. Resmi Sebastian (PI) and Dr. Raheena M (Co-PI)"
      },
      {
        "title": "Slope Monitoring and Landslide Hazard Quantification for Hilly Roads",
        "agency": "NHAI",
        "amount": "₹78.00",
        "pi": "Dr. Naveen James, Dr. Reet Kamal Tiwari and Dr. C. K. Narayanan"
      },
      {
        "title": "Analysis of Evacuation Options considering Citizen Mobility Patterns and Disaster Vulnerability in a Himalayan Region Transportation Network",
        "agency": "National Mission of Himalayan Studies (NMHS)",
        "amount": "₹44.82",
        "pi": "Dr. Rahul TM (IIT Ropar), Dr. Manoj M (IIT Delhi), Dr. Bhavathrathan B K (IIT Palakkad)"
      },
      {
        "title": "Compendium of Traditional Earthquake Resilient Construction for Knowledge Sharing and Disaster Risk Reduction: Promotion of Traditional Construction Practices",
        "agency": "NDMA",
        "amount": "₹25.00",
        "pi": "Dr. Mitesh Surana (PI) and Dr. PutulHaldar (Co-PI)"
      },
      {
        "title": "A feasibility study on aquifer storage of water by artificial recharge in and around Punjab region, India",
        "agency": "SERB-SRG",
        "amount": "₹32.49",
        "pi": "Dr. Sayantan Ganguly"
      },
      {
        "title": "Estimation and validation of seasonal snow cover maps using Ku-band SCATSAT-1 data over the Western Himalaya, India",
        "agency": "SERB-TARE",
        "amount": "₹10.00",
        "pi": "Dr. Sartajvir Singh, Chitkara University, Atal Shiksha Kunj, Atal Nagar, Barotiwala, Solan, Himachal Pradesh under the mentorship of Dr. Reet Kamal Tiwari"
      },
      {
        "title": "Propagation and Attenuation of Shear Waves Inducing High Strains in Jointed Rocks",
        "agency": "SERB – ECR",
        "amount": "₹47.89",
        "pi": "Dr. Resmi Sebastian"
      },
      {
        "title": "Analytical solution of the hillslope Boussinesq equation considering unsteady boundary and variable recharge with bedrock seepage",
        "agency": "SERB",
        "amount": "₹28.00",
        "pi": "Dr. Ratan Sarmah"
      },
      {
        "title": "Next Generation Earthquake Loss Estimation Tool for Hilly Regions",
        "agency": "SERB-IMPRINT",
        "amount": "₹68.00",
        "pi": "Dr. PutulHaldar (Co-PI), Dr. Mitesh Surana (Co-PI)"
      },
      {
        "title": "Understanding and Modeling the Reactive Transport of Uranium Contaminated Groundwater of Malwa Region, Punjab",
        "agency": "SERB-DST",
        "amount": "₹28.00",
        "pi": "Dr. L. Vijay Anand"
      },
      {
        "title": "Impact of rainwater harvesting in India on groundwater quality with specific reference to fluoride and micro pollutants",
        "agency": "Newton-Bhabha Grant (India-UK)",
        "amount": "₹75.00",
        "pi": "Prof. Deepak Kashyap"
      },
      {
        "title": "Terrain Modelling and Its Application in Landslide Hazard/Risk Assessment",
        "agency": "ISRO’s Disaster Management Support Programme (DMSP)",
        "amount": "₹28.17",
        "pi": "Dr. Reet Kamal Tiwari and Dr. Naveen James"
      },
      {
        "title": "Permafrost destabilization induced mass wasting vulnerable zones modelling in higher Himalayan regions (Bhagirathi-Alaknanda Valley) through Snow cover-climate-terrain interactive mechanism employing Deep Learning techniques",
        "agency": "ISRO’s Disaster Management Support Programme (DMSP)",
        "amount": "₹39.20",
        "pi": "Dr. Reet Kamal Tiwari (CO-PI)"
      },
      {
        "title": "Sustainable Agricultural Planning for Small Farm Holders in Bist Doab Region of Punjab",
        "agency": "MIT USA",
        "amount": "₹13500 USD",
        "pi": "Dr. Ickkshaanshu Sonkar (PI), Dr. Reet Kamal Tiwari (Co-PI)"
      },
      {
        "title": "Mapping agriculture and yields forecasting over India using high-resolution microwave remote sensing",
        "agency": "MIT USA",
        "amount": "₹14,475 USD",
        "pi": "Dr. Reet Kamal Tiwari"
      },
      {
        "title": "Natural Fibre Reinforced Cementitious Composite for Sustainable Infrastructure",
        "agency": "DST, India-Austria Collaboration",
        "amount": "₹12.852",
        "pi": "Dr. Aditya Singh Rajput (Co-PI)"
      },
      {
        "title": "Durability of Concrete Repair and Protection Systems",
        "agency": "USHTA Infinity Pvt. Ltd.",
        "amount": "₹18.28",
        "pi": "Dr. Aditya Singh Rajput (Co-PI)"
      },
      {
        "title": "Evaluation and Retrofitting of Existing Buildings for Safe and Sustainable Built Environment",
        "agency": "DST, India-Portugal Collaboration",
        "amount": "₹48.82",
        "pi": "Dr. Mitesh Surana (Co-PI), Dr. Aditya Singh Rajput (Co-PI)"
      },
      {
        "title": "Analyzing pattern of urban growth and prediction of future sprawl in and around Chandigarh city using geospatial techniques",
        "agency": "SERB-N-PDF",
        "amount": "₹19",
        "pi": "Dr. Varinder Saini, NPDF under the mentorship of Dr. Reet Kamal Tiwari"
      },
      {
        "title": "Impact of rainwater harvesting in India on groundwater quality with specific reference to fluoride and micropollutants",
        "agency": "Newton-Bhabha Grant (India-UK)",
        "amount": "₹75",
        "pi": "Prof. Deepak Kashyap"
      },
      {
        "title": "Understanding and Modeling the Reactive Transport of Uranium Contaminated Groundwater of Malwa Region, Punjab",
        "agency": "SERB-DST",
        "amount": "₹28",
        "pi": "Dr. L. Vijay Anand"
      },
      {
        "title": "Micro Green Roofing",
        "agency": "SERB-IMPRINT",
        "amount": "₹58",
        "pi": "Dr. Prabir Sarkar (PI), Dr. Putul Haldar (Co-PI)"
      },
      {
        "title": "Next Generation Earthquake Loss Estimation Tool for Hilly Regions",
        "agency": "SERB-IMPRINT",
        "amount": "₹35",
        "pi": "Dr. Putul Haldar (Co-PI)"
      },
      {
        "title": "Analytical solution of the hillslope Boussinesq equation considering unsteady boundary and variable recharge with bedrock seepage",
        "agency": "SERB",
        "amount": "₹28",
        "pi": "Dr. Ratan Sarmah"
      },
      {
        "title": "Propagation and Attenuation of Shear Waves Inducing High Strains in Jointed Rocks",
        "agency": "SERB",
        "amount": "₹48",
        "pi": "Dr. Resmi Sebastian"
      },
      {
        "title": "Impact of Climate Change and Chloride-Induced Corrosion Damage Risks of Concrete Infrastructure Deterioration Along Coastal Regions of India",
        "agency": "SERB",
        "amount": "₹33",
        "pi": "Dr. Muthulingam Subramaniyan"
      },
      {
        "title": "Estimation and validation of seasonal snow cover maps using Ku-band SCATSAT-1 data over the Western Himalaya, India",
        "agency": "SERB-TARE",
        "amount": "₹10",
        "pi": "Dr. Sartajvir Singh, Chitkara University, Atal Shiksha Kunj, Atal Nagar, Barotiwala, Solan, Himachal Pradesh under the mentorship of Dr. Reet Kamal Tiwari"
      },
      {
        "title": "A feasibility study on aquifer storage of water by artificial recharge in and around Punjab region, India",
        "agency": "SERB-CRG",
        "amount": "₹32",
        "pi": "Dr. Sayantan Ganguly"
      },
      {
        "title": "Seismic Characterization and Vulnerability of Vernacular and Contemporary Buildings in the Indian Himalayas",
        "agency": "NDMA",
        "amount": "₹11",
        "pi": "Dr. Mitesh Surana"
      },
      {
        "title": "Commute Travel Choices in India – Gender Perspective Solutions",
        "agency": "SERB-ECR",
        "amount": "₹18",
        "pi": "Dr. Rahul TM"
      },
      {
        "title": "Analysis of Evacuation Options Considering Citizen Mobility Patterns and Disaster Vulnerability in a Himalayan Region Transportation Network",
        "agency": "National Mission of Himalayan Studies (NMHS)",
        "amount": "₹14",
        "pi": "Dr. Rahul TM"
      },
      {
        "title": "Slope Monitoring and Landslide Hazard Quantification for Hilly Roads",
        "agency": "NHAI",
        "amount": "₹78",
        "pi": "Dr. Naveen James, Dr. Reet Kamal Tiwari, and Dr. C. K. Narayanan"
      },
      {
        "title": "Utilisation of rice husk ash, bagasse ash and bottom ash in highway embankment",
        "agency": "NHAI",
        "amount": "₹53",
        "pi": "Dr. Resmi Sebastian (PI)"
      },
      {
        "title": "Development of low-cost Artificial Intelligence System for early detection of landslide",
        "agency": "DST-NRDMS",
        "amount": "₹43",
        "pi": "Dr. Naveen James, Dr. Reet Kamal Tiwari, and Dr. C. K. Narayanan"
      },
      {
        "title": "Analysis, Design & Optimization of Semi-Flexible Snow Supporting Structures",
        "agency": "DGRE-CARS",
        "amount": "₹4",
        "pi": "Dr. Muthulingam Subramaniyan"
      },
      {
        "title": "Impact of the Covid-19 pandemic on travel behavior of people",
        "agency": "ICSSR",
        "amount": "₹4",
        "pi": "Dr. Rahul TM"
      },
      {
        "title": "Sustainable Agricultural Planning for Small Farm Holders in BIST Doab Region of Punjab",
        "agency": "Massachusetts Institute of Technology (MIT)",
        "amount": "₹10",
        "pi": "Dr. Ickkshaanshu Sonkar (PI), Dr. Reet Kamal Tiwari (Co-PI)"
      },
      {
        "title": "Terrain Modelling and its Application in Landslide Hazard/Risk Assessment",
        "agency": "DMSP-ISRO",
        "amount": "₹28",
        "pi": "Dr. Reet Kamal Tiwari (PI)"
      },
      {
        "title": "Satellite image based subpixel change detection of snow/ice cover over Himalayas",
        "agency": "DST-WOS-A",
        "amount": "₹27",
        "pi": "Dr. Vishakha Sood (Dr. Reet Kamal Tiwari, Mentor)"
      },
      {
        "title": "Potential Utilization of Recycled Wool Fabric for Geo-synthetic Applications",
        "agency": "Punjab State Council for Science & Technology (PSCST)",
        "amount": "₹10",
        "pi": "Dr. Naveen James, Dr. Resmi Sebastian, and Dr. Raheena M (PIs)"
      },
      {
        "title": "Climate Change and its Impact Assessment of Rice and Wheat Cropping in Punjab; a Way Towards Sustainable Agricultural Practices",
        "agency": "SMTP-Mission Tandrust Punjab",
        "amount": "₹8",
        "pi": "Dr. Ickkshaanshu Sonkar"
      },
      {
        "title": "Deep Learning-Based Automated Mapping of Glacial Lakes in the Himalayas",
        "agency": "DST-NGP",
        "amount": "₹39",
        "pi": "Dr. Reet Kamal Tiwari (PI)"
      },
      {
        "title": "Permafrost Destabilization Induced Mass Wasting Vulnerable Zones Modelling in Higher Himalayan Regions (Bhagirathi-Alaknanda Valley) Through Snow Cover-Climate-Terrain Interactive Mechanism Employing Deep Learning Techniques",
        "agency": "ISRO-DMSP",
        "amount": "₹39",
        "pi": "Dr. Reet Kamal Tiwari (Co-PI)"
      },
      {
        "title": "Development of Remote Sensing Based Dynamic Decision Support (DSS) System for Avalanche Susceptibility Mapping Using AI/ML Techniques For NW-Himalaya",
        "agency": "DRDO-DGRE-CARS",
        "amount": "₹49",
        "pi": "Dr. Reet Kamal Tiwari"
      },
      {
        "title": "Development Of An Algorithmic Procedure to Extract Geomorphological Attributes Governing Floods in Headwater Catchments and Evaluating Their Potential in Predicting Design Floods at Ungauged Locations",
        "agency": "SERB-CRG",
        "amount": "₹28",
        "pi": "Dr. Sagar Rohidas Chavan"
      },
      {
        "title": "Seismic Design Provisions to Incorporate Amplification in Force Demands on Acceleration-Sensitive Secondary Systems Due to Building Irregularities",
        "agency": "SERB-CRG",
        "amount": "₹20",
        "pi": "Dr. Mitesh Surana"
      },
      {
        "title": "How to Improve the Penetration of Electric Vehicles in the Indian Market - Understanding Effect of Government Policies and People’s Perceptions on Electric Vehicle Adoption",
        "agency": "SERB-CRG",
        "amount": "₹22",
        "pi": "Dr. Rahul TM"
      },
      {
        "title": "Seismic Vulnerability and Risk Assessment in Hilly Region (SeisVARA_Hill)",
        "agency": "The Coalition for Disaster Resilient Infrastructure (CDRI)",
        "amount": "15000 USD",
        "pi": "Dr. Putul Haldar"
      },
      {
        "title": "Assessment of Local Site Effects Specific to State of Punjab: A Pre-Requisite for Seismic Risk Reduction",
        "agency": "State Disaster Mitigation Fund (SDMA) Punjab",
        "amount": "₹98.24",
        "pi": "Putul Haldar, Co-PI: Dr. Naveen James, and Dr. Shrabony Adhikary"
      },
      {
        "title": "Earthquake Risk and Engineering towards Seismic Safety of Building Stock in Punjab",
        "agency": "State Disaster Mitigation Fund (SDMA) Punjab",
        "amount": "₹92.59",
        "pi": "Dr. Putul Haldar"
      },
      {
        "title": "Development of Indigenous Seismic Vulnerability And Risk Assessment (SeisVARA) Tool Tailored for the State of Punjab",
        "agency": "State Disaster Mitigation Fund (SDMA) Punjab",
        "amount": "₹80.60",
        "pi": "Dr. Putul Haldar"
      },
      {
        "title": "Development Of An Algorithmic Procedure to Extract Geomorphological Attributes Governing Floods in Headwater Catchments and Evaluating Their Potential in Predicting Design Floods at Ungauged Locations",
        "agency": "SERB-CRG",
        "amount": "₹28",
        "pi": "Dr. Sagar Rohidas Chavan"
      },
      {
        "title": "Seismic Design Provisions to Incorporate Amplification in Force Demands on Acceleration-Sensitive Secondary Systems Due to Building Irregularities",
        "agency": "SERB-CRG",
        "amount": "₹20",
        "pi": "Dr. Mitesh Surana"
      },
      {
        "title": "How to Improve the Penetration of Electric Vehicles in the Indian Market - Understanding Effect of Government Policies and People’s Perceptions on Electric Vehicle Adoption",
        "agency": "SERB-CRG",
        "amount": "₹22",
        "pi": "Dr. Rahul TM"
      }
]


const Completed_data =[
    {
        "title": "Analysis, Design & Optimization of Semi Flexible Snow Supporting Structures",
        "agency": "DGRE-CARS",
        "amount": "₹4.00",
        "pi": "Dr. Muthulingam Subramaniyan"
      },
      {
        "title": "COMMUTE TRAVEL CHOICES IN INDIA – GENDER PERSPECTIVE SOLUTIONS",
        "agency": "SERB-ECR",
        "amount": "₹18.00",
        "pi": "Dr. Rahul TM"
      },
      {
        "title": "Analyzing pattern of urban growth and prediction of future sprawl in and around Chandigarh city using geospatial techniques",
        "agency": "SERB",
        "amount": "₹19.00",
        "pi": "Dr. Varinder Saini Under the mentorship of Dr. Reet Kamal Tiwari"
      }
]




export default function Research() {
  return (
    <>
          <Nav />
    
          <div className="main-container">
            <div className="page-banner">
              <div className="text">
                <p><Link to="https://www.iitrpr.ac.in/civil/" className="backlink" style={{color:"white", textDecoration:"none", cursor:"pointer"}}>Home</Link> / Research</p>
              </div>
            </div>
    
            <div className="res-middle">
              <div className="res-content">
                <p className="top-p">Research</p>
                <p className="lower-p">Publication</p>
                <div className="res-list-animation">
                  <ul>
                    <li><Link to="/research/2024">2024</Link></li>
                    <li><Link to="/research/2023">2023</Link></li>
                    <li><Link to="/research/2022">2022</Link></li>
                    <li><Link to="/research/2021">2021</Link></li>
                    <li><Link to="/research/2020">2020</Link></li>
                    <li><Link to="/research/2019">2019</Link></li>
                    <li><Link to="/research/2018">2018</Link></li>
                    <li><Link to="/research/2017">2017</Link></li>
                  </ul>
                </div>
                <p className="middle-p" style={{ marginTop: "20px" }}>
                Consultancy Project
                </p>
                <p className="middle-p" style={{ marginBottom: "15px" }}>
                # 33 – Over ₹ 5 Cr.
                </p>
                <div className="res-list">
                  <ul>
                    <li>Structural Engineering</li>
                    <li>Geotechnical Engineering</li>
                    <li>Environmental Engineering</li>
                    <li>Transportation Engineering</li>
                    <li>Geomatics</li>
                    <li>Water Recourses</li>
                  </ul>
                </div>
                <p className="middle-p" style={{ marginTop: "20px" }}>
                  Consultancy Project
                </p>
                <p
                  className="middle-p"
                  style={{ fontSize: "30px", marginBottom: "15px" }}
                >
                  # 23 – Over ₹ 5 Cr.
                </p>
    
    
                {/* ------------table------------------ */}
    
                <div className="table-div">
                  <table>
                    <tr>
                      <th>S.No</th>
                      <th>Title</th>
                      <th>Funding Agency & Scheme</th>
                      <th>Total Amount (Lakhs)</th>
                      <th>PI/Co-PI</th>
                    </tr>
    
                    {data.map((item, index) => (
    
                      <tr key={item.id}>
                        <td>{index+1}</td>
                        <td>{item.title}</td>
                        <td>{item.agency}</td>
                        <td>{item.amount}</td>
                        <td>{item.pi}</td>
                      </tr>
                    ))}
                  </table>
                </div>

                <p style={{fontSize:"20px", fontWeight:"bold", marginTop:"40px"}}>Completed</p>

                 
                <div className="table-div" style={{height:"max-content"}}>
                  <table>
                    <tr>
                      <th>S.No</th>
                      <th>Title</th>
                      <th>Funding Agency & Scheme</th>
                      <th>Total Amount (Lakhs)</th>
                      <th>PI/Co-PI</th>
                    </tr>
    
                    {Completed_data.map((item, index) => (
    
                      <tr key={item.id}>
                        <td>{index+1}</td>
                        <td>{item.title}</td>
                        <td>{item.agency}</td>
                        <td>{item.amount}</td>
                        <td>{item.pi}</td>
                      </tr>
                    ))}
                  </table>
                </div> 
                
              </div>
            </div>
          </div>
    
          <Footer />
        </>
  )
}
